import React, { useRef } from 'react'
import './styles.css'

interface Props{
  todo:string;
  setTodo:React.Dispatch<React.SetStateAction<string>>;
  handleAdd: (e : React.FormEvent) => void ;
}

const InputField = ({todo, setTodo , handleAdd} : Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <form className='InputField' onSubmit={(e)=>{
      handleAdd(e); 
      inputRef.current?.blur()}}
    >
        <input ref={inputRef} type="input" placeholder='Enter a new task' value={todo} onChange={(e)=> setTodo(e.target.value)} className='Input'/>
        <button className='SubmitBtn' type='submit'>Add</button>
    </form>
  )
}

export default InputField